import { render, staticRenderFns } from "./PopupAddTest.vue?vue&type=template&id=674c6fa6&scoped=true"
import script from "./PopupAddTest.vue?vue&type=script&lang=js"
export * from "./PopupAddTest.vue?vue&type=script&lang=js"
import style0 from "./PopupAddTest.vue?vue&type=style&index=0&id=674c6fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c6fa6",
  null
  
)

export default component.exports